<template>
<div
    v-if="my_value != null"
>
    <v-row>

        <v-col>
            <v-select
                label="Time Period"
                :items="$rc.enumValues('time_period', false)"
                :value="my_value.period"
                v-on:change="onChangePeriod"
            />
        </v-col>

        <v-col
            v-if="show_time_bin_by"
        >
            <v-select
                label="By"
                :items="$rc.enumValues('time_bin_by', false)"
                v-model="my_value.time_bin_by"
                v-on:change="update"
            />
        </v-col>


        <v-col
            style="max-width: 150px"
        >
            <m-edit-date
                label="Start Date"
                v-model="my_value.date_start"
                v-on:input="update"
                :read_only="my_value.period != 'custom'"
            />
        </v-col>

        <v-col
            style="max-width: 150px"
        >
            <m-edit-date
                label="Stop Date"
                v-model="my_value.date_stop"
                v-on:input="update"
                :read_only="my_value.period != 'custom'"
            />
        </v-col>

    </v-row>

    <div
        v-if="my_value.time_bin_by == 'week'"
        style="margin-bottom: 15px"
    >
        <b>Note:</b> Data will be presented by International Organization for Standards (ISO) week number.  Please note that when a year begins mid-week, that midweek portion is, per the ISO standards, part of week 52 of the prior year and will be labeled as such. 
    </div>


</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {
        value: {
            type: Object,
            default: function() { return { 'period': 'last-month' }; } 
        },

        show_time_bin_by: {
            type: Boolean,
            default: function() { return true; }
        }
    },

    data() {
        return {
            my_value: null,
        }
    },

    mounted () {

        this.update();
    },

    methods: {
        update() {
            let params = _.cloneDeep(this.my_value ?? this.value ?? {});

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/analytics/complete-time-period',
            
                'params' : params,
            
                'on_success': (data) => 
                {
                    this.my_value = _.cloneDeep(data);

                    if ( !_.isEqual(this.value, this.my_value) )
                    {
                        this.$emit('input', data);
                    }
                },
            
                'on_error': 'Unable to update time period',
            });
        },

        onChangePeriod(new_period)
        {
            this.my_value.period = new_period;
            this.my_value.time_bin_by = null; 
            this.update();
        },
    },

    watch: {
        value(newValue, oldValue) {
            
            if ( _.isEqual(this.my_value, this.value) )
                return;

            this.my_value = _.cloneDeep(this.value);
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>